module.exports = __webpack_public_path__ + "img/text-align-left.60acb907.svg";